/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/function-component-definition */
/* eslint-disable comma-spacing */
import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { Divider, Drawer, Form } from 'antd';

import DrawerSubmitFooter from '../common/containers/DrawerSubmitFooter';
import OnTraccrNumberInput from '../common/inputs/OnTraccrNumberInput';
import PaginatedTable from '../common/containers/PaginatedTable';

import {
  currencyFormatter,
  currencyParser,
  markupPercentFormatter,
  percentParser,
} from '../helpers/inputParsers';

import { getPreviewColumns } from './materialTableColumns';

import { changeIsNumber } from './materialsHelpers';
import { convertLowerCamelCaseToText } from '../helpers/helpers';

export default ({
  type,
  costType = "material",
  visible,
  onClose,
  onSubmit,
  selected = [],
}) => {
  const isCost = type === 'Cost';
  const [change,setChange] = useState();

  const onSubmitClicked = useCallback(() => {
    onSubmit(change);
  },[change]);

  const numberInputProps = useMemo(() => (
    (isCost) ? {
      formatter: currencyFormatter,
      parser: currencyParser,
      precision: 2,
      step: 0.01,
    } : {
      formatter: markupPercentFormatter,
      parser: percentParser,
      precision: 5,
      step: 0.00001,
    }
  ),[isCost]);

  const columns = useMemo(() => (
    getPreviewColumns({ type, costType, change })
  ), [type, costType, change]);
  const canSubmit = useMemo(() => changeIsNumber(change),[change]);

  useEffect(() => {
    if(!visible) setChange();
  },[visible]);
  const title = type && costType ? `${convertLowerCamelCaseToText(costType)} ${convertLowerCamelCaseToText(type)}` : type;

  return (
    <Drawer
      title={`Change ${title} for ${selected.length} items`}
      width={800}
      visible={visible}
      onClose={onClose}
    >
      <Form.Item label='Enter change'>
        <OnTraccrNumberInput
          style={{ width: '100%' }}
          {...numberInputProps}
          onChange={setChange}
          value={change}
        />
      </Form.Item>
      <Divider/>
      <PaginatedTable
        className='materials-table'
        scroll={{ x:'max-content' }}
        pagination={false}
        size='small'
        rowKey='id'
        columns={columns}
        dataSource={selected}
        scrollOffset={305}
      />
      <DrawerSubmitFooter
        onClose={onClose}
        onSubmit={onSubmitClicked}
        canSubmit={canSubmit}
      />
    </Drawer>
  )
}
